import { render, staticRenderFns } from "./GameCounter.vue?vue&type=template&id=e4e7a55e&scoped=true&"
import script from "./GameCounter.vue?vue&type=script&lang=js&"
export * from "./GameCounter.vue?vue&type=script&lang=js&"
import style0 from "./GameCounter.vue?vue&type=style&index=0&id=e4e7a55e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4e7a55e",
  null
  
)

export default component.exports